import { msg, content, _logout, noti } from "src/utils/functions/core"
const queryFetch = require("./queryFetch");

const allinWeb = async (docType, type) => {
  const get = await setAllinOneWeb(docType, type)
  return get
}

const setAllinOneWeb = (docType, type) => {
  // const { token } = content()
  if (docType && type) {
    return queryFetch.querySelectCustom({
      url: "/api/select_querySelectGetWeb",
      token: "token",
      data: { docType, type }
    }).then(res => {
      res?.msg && msg(...res?.msg)
      res?.noti && noti(...res?.noti)
      return res
      // if (res) {
      //   return res
      // } else {
      //   // console.log(res.msg)
      //   // msg(...res.msg)
      //   return false
      // }
    })
  } else {
    return false
  }
}

const allinOne = async (docType, type) => {
  const get = await setAllinOne(docType, type)
  return get
}

const setAllinOne = (docType, type) => {
  const { token } = content()
  if (docType && type && token) {
    return queryFetch.querySelectCustom({
      url: "/api/select_querySelectGet",
      token: token,
      data: { docType, type }
    }).then(res => {
      // console.log(res?.logout)
      res?.msg && msg(...res?.msg)
      res?.noti && noti(...res?.noti)
      if (res?.logout) {
        _logout()
      }
      return res
      // if (res) {
      //   return res
      // } else {
      //   // console.log(res.msg)
      //   // msg(...res.msg)
      //   return false
      // }
    })
  } else {
    return false
  }
}

const allinPut = async (docType, type) => {
  const get = await setAllinPut(docType, type)
  return get
}

const setAllinPut = (docType, type) => {
  const { token } = content()
  if (docType && type && token) {
    return queryFetch.querySelectPut({
      url: "/api/select_querySelectPut",
      token: token,
      data: { docType, type }
    }).then(res => {
      // console.log(res?.logout)
      res?.msg && msg(...res?.msg)
      res?.noti && noti(...res?.noti)
      if (res?.logout) {
        _logout()
      }
      return res
      // if (res.success) {
      //   // msg("success", (lang?.["saved"] ?? "saved"), 2)
      //   return res
      // } else {
      //   // console.log(res)
      //   // msg("error", (lang?.[res?.msg] ?? res?.msg), 2)
      //   return false
      // }
    })

  } else {
    return false
  }
}

const allinPost = async (docType, type) => {
  const get = await setAllinPost(docType, type)
  return get
}

const setAllinPost = (docType, type) => {
  const { token } = content()
  if (docType && type && token) {
    return queryFetch.querySelectPost({
      url: "/api/select_querySelectPost",
      token: token,
      data: { docType, type }
    }).then(res => {
      // console.log(res?.logout)
      res?.msg && msg(...res?.msg)
      res?.noti && noti(...res?.noti)
      if (res?.logout) {
        _logout()
      }
      return res
      // console.log(res)
      // if (res.success) {
      //   // msg("success", (lang?.["saved"] ?? "saved"), 2)
      //   return res
      // } else {
      //   // console.log(res)
      //   // msg("error", (lang?.[res?.msg] ?? res?.msg), 2)
      //   return false
      // }
    })

  } else {
    return false
  }
}

const allinDelete = async (docType, type) => {
  const get = await setAllinDelete(docType, type)
  return get
}

const setAllinDelete = (docType, type) => {
  const { lang, token } = content()
  if (docType && type && token) {
    return new Promise((resolve, reject) => {
      queryFetch.querySelectDelete({
        url: "/api/select_querySelectDelete",
        token: token,
        data: { docType, type }
      }).then(res => {
        if (res) {
          resolve(res)
        } else {
          resolve(false)
        }
      })
    });
  } else {
    return false
  }
}

const checkPromisStatus = (e) => {
  if (e.status === "fulfilled")
    return e.value
  else return false
}

const checkPromis = (e) => {
  if (e.status === "fulfilled")
  if (e?.value?.result === false) {
    return { value: false, msg: e?.value?.msg }
  }else {
    return { value: e.value }
  }else {
    return { value: false }
  }
}


export { allinOne, allinPut, allinDelete, checkPromisStatus, checkPromis, allinPost, allinWeb }
